var exports = {
  "DS": "NewViewExperienceContainer__khFf8m",
  "P_": "textContent__uddvbt",
  "DZ": "Heading__3-TqK0",
  "ij": "descriptionText__Lk1EBj",
};

module.exports = exports;
